/*
  Montrelio — indicateur de défilement horizontal (mobile).

  Plusieurs rails de la boutique défilent latéralement en mobile ; rien ne le
  signalait, donc une partie du contenu restait invisible pour qui ne pense pas
  à faire glisser. Ce fichier pose une flèche discrète au bord droit de chaque
  rail réellement débordant, et l'efface dès le premier défilement.

  Choix d'implémentation :
   - Liste de sélecteurs EXPLICITE plutôt qu'une détection automatique de tous les
     conteneurs à overflow : on ne veut pas décorer les scrollers internes du thème
     (galerie produit, menu, facettes) ni ceux du panier.
   - La flèche est un élément ajouté au PARENT du rail (pas au rail lui-même) :
     plusieurs de ces rails sont des grilles en `grid-auto-flow: column`, où un
     enfant supplémentaire deviendrait une colonne de plus.
   - Rien ne s'exécute au-dessus de 749 px : en desktop ces rails ne débordent pas.
*/
(function () {
  if (window.__mScrollHintInit) return;
  window.__mScrollHintInit = true;

  /* 08.08.2026 — les rails de PRODUITS (.msc__grid, .mtabs__grid, .mtr-cols__strip)
     ont été retirés de cette liste : depuis l'unification des flèches de carrousel,
     ils portent de vraies flèches de navigation en mobile aussi. L'indicateur y
     ajoutait une seconde flèche, plus basse, juste sous la vraie. Ne restent ici
     que les rails qui n'ont pas de flèches propres. */
  var SELECTORS = [
    '.mse__chips',       /* recherche — pastilles d'intention */
    '.mbb-rv__grid'      /* fiche produit — avis en colonnes */
  ].join(',');

  var MOBILE = '(max-width: 749px)';

  function isScrollable(el) {
    return el.scrollWidth - el.clientWidth > 8;
  }

  /* Le parent peut etre BEAUCOUP plus haut que le rail (sur la home il englobe les
     onglets et le bouton) : un top: 50%% en CSS placait donc la fleche trop bas.
     On la cale sur la geometrie du rail, pas sur celle de son hote. */
  function place(rail, hint) {
    var host = hint.parentElement;
    if (!host) return;
    hint.style.top = (rail.offsetTop + rail.offsetHeight / 2) + 'px';
    hint.style.right = Math.max(0, host.clientWidth - (rail.offsetLeft + rail.offsetWidth)) + 'px';
  }

  function clear(rail) {
    if (rail.__mhint) {
      rail.__mhint.remove();
      rail.__mhint = null;
    }
  }

  function attach(rail) {
    /* __mhintDone : le rail a DEJA ete defile. Sans cette memoire, le MutationObserver
       relance refresh() et repose la fleche juste apres sa suppression. */
    if (rail.__mhint || rail.__mhintDone || !isScrollable(rail)) return;
    var host = rail.parentElement;
    if (!host) return;

    /* Le parent doit être un contexte de positionnement. On ne le force que sur
       les hôtes de nos rails, jamais globalement. */
    if (getComputedStyle(host).position === 'static') host.style.position = 'relative';

    var hint = document.createElement('span');
    hint.className = 'mshint';
    hint.setAttribute('aria-hidden', 'true');
    hint.innerHTML =
      '<svg viewBox="0 0 24 24" width="15" height="15" fill="none" stroke="currentColor" ' +
      'stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><path d="M9 6l6 6-6 6"/></svg>';
    host.appendChild(hint);
    rail.__mhint = hint;
    place(rail, hint);

    /* Premier défilement = message reçu, la flèche disparaît pour de bon. */
    rail.addEventListener(
      'scroll',
      function onScroll() {
        if (rail.scrollLeft > 8) {
          rail.__mhintDone = true;
          clear(rail);
          rail.removeEventListener('scroll', onScroll);
        }
      },
      { passive: true }
    );
  }

  function refresh() {
    var mobile = window.matchMedia(MOBILE).matches;
    document.querySelectorAll(SELECTORS).forEach(function (rail) {
      if (!mobile || !isScrollable(rail)) clear(rail);
      else if (rail.__mhint) place(rail, rail.__mhint);
      else attach(rail);
    });
  }

  var t = null;
  function schedule() {
    if (t) return;
    t = setTimeout(function () { t = null; refresh(); }, 200);
  }

  function onReady(fn) {
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', fn);
    else fn();
  }

  onReady(function () {
    refresh();
    window.addEventListener('resize', schedule, { passive: true });
    /* Les onglets de collections remplacent leur contenu sans recharger la page :
       il faut réévaluer après coup. */
    try {
      new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true });
    } catch (e) {}
  });
})();
